import useTranslator from "../../hooks/useTranslator";
import ProfileImg from "../../assets/img/profileImg.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import {
  cleanIdentityNumber,
  formatDateOfBirth,
  getIdentityDetails,
  getUserDisplayName,
  haveValue,
} from "../../helper/common";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import { useState } from "react";
import constants from "../../Utils/constants";

const DetailsPersonalInfo = (props) => {
  const {
    user = null,
    forensicAnalysis = {},
    handleInfoModal,
    currentLang,
    llShowOnly,
  } = props;
  const { _t } = useTranslator();

  // Sending this true as we need to show the document_number or personal_number except spain, for spain case it works fine, for other we need that fallback.
  const needOnfidoResult = true;
  const kycDetails = getIdentityDetails(
    user,
    user?.onfido_user_kyc,
    needOnfidoResult
  );

  const isSameValue = (a, b) => {
    const cleanValueA = cleanIdentityNumber(a);
    const cleanValueB = cleanIdentityNumber(b);

    return haveValue(cleanValueA) && cleanValueA === cleanValueB;
  };

  const isOnfidoName = haveValue(
    user?.onfido_user_kyc?.onfido_doc_data?.first_name
  );

  const dniExtraValue = cleanIdentityNumber(
    forensicAnalysis?.DNI?.dataInJSON?.dni
  );
  const passportExtraValue = cleanIdentityNumber(
    forensicAnalysis?.Passport?.dataInJSON?.passportNumber
  );

  const isOnfidoNationality = haveValue(user?.nationality);
  const isForensicNationality =
    !isOnfidoNationality &&
    haveValue(forensicAnalysis?.Nationality?.dataInJSON?.nationality);
  const canOpenNationalityModal = isForensicNationality && llShowOnly;

  return (
    <>
      <div className="main_doc_div">
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={ProfileImg} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("personalInformation")}</p>
        </div>
        <div className="row">
          {/* Name field */}
          <div className="col-md-4">
            <div
              className={`Indo_form BorderB2 `}
              // ${
              // haveValue(forensicAnalysis?.Name) && llShowOnly
              //   ? "custom-tooltip cursor-pointer"
              //   : ""
              // }
              // `}
              // data-tooltip={_t("clickHereToSeeDetails")}
              // onClick={(e) => {
              //   if (haveValue(forensicAnalysis?.Name) && llShowOnly) {
              //     handleInfoModal(forensicAnalysis?.Name);
              //   }
              // }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("name")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.Name?.verifiedSource === true ||
                  isOnfidoName ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">{getUserDisplayName(user)}</p>
            </div>
          </div>

          {haveValue(kycDetails?.value) && (
            <div className="col-md-4 col-6">
              <div className={`Indo_form BorderB2`}>
                <div className="d-flex align-items-center gap-1">
                  <p className="formlabel d-block">
                    {_t(
                      kycDetails?.type === "passport" ? "passport" : "dniNie"
                    )}
                  </p>
                  {kycDetails?.showTick && (
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    </div>
                  )}
                </div>

                <p className="placeholderTest">{kycDetails?.value ?? ""}</p>
              </div>
            </div>
          )}

          {/* Nationality field */}
          <div className="col-md-4 col-6">
            <div
              className={`Indo_form BorderB2 ${
                canOpenNationalityModal ? "cursor-pointer custom-tooltip" : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={() => {
                if (canOpenNationalityModal) {
                  handleInfoModal(forensicAnalysis?.Nationality);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("nationality")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {isOnfidoNationality ||
                  (isForensicNationality &&
                    forensicAnalysis?.Nationality?.verifiedSource === true) ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {isOnfidoNationality
                  ? _t(user?.nationality, "", "fixed")
                  : isForensicNationality
                    ? _t(
                        forensicAnalysis?.Nationality?.dataInJSON?.nationality,
                        "",
                        "fixed"
                      )
                    : _t("na")}
              </p>
            </div>
          </div>

          {/* Phone Number field */}
          <div className="col-md-4 col-6">
            <div className="Indo_form BorderB2">
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("phoneNumber")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {user?.phone_number_verified && (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {user?.phone_number ? `+${user?.phone_number}` : _t("na")}
              </p>
            </div>
          </div>

          {/* Email field */}
          <div className="col-md-4">
            <div className="Indo_form BorderB2">
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("email")}</p>
                <div className=" d-flex align-items-center gap-1">
                  <img
                    src={CheckIcon0}
                    alt="Vector Icon"
                    className="validationIcon"
                  />
                </div>
              </div>
              <p className="placeholderTest userEmailText">{user?.email}</p>
            </div>
          </div>

          {/* Date of Birth field */}
          {llShowOnly &&
            user?.employment_status?.toLowerCase() ===
              constants.employed.toLowerCase() && (
              <div className="col-md-4">
                <div className="Indo_form BorderB2">
                  <div className="d-flex align-items-center gap-1">
                    <p className="formlabel d-block">{_t("dob")}</p>
                    <div className=" d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    </div>
                  </div>
                  <p className="placeholderTest userEmailText">
                    {formatDateOfBirth(user?.dob, currentLang)}
                  </p>
                </div>
              </div>
            )}

          {/* DNI/NIE Extra field */}
          {haveValue(dniExtraValue) &&
            !isSameValue(dniExtraValue, kycDetails?.value) && (
              <div className="col-md-4 col-6">
                <div
                  className={`Indo_form BorderB2 ${
                    llShowOnly ? "custom-tooltip cursor-pointer" : ""
                  }`}
                  data-tooltip={_t("clickHereToSeeDetails")}
                  onClick={() => {
                    if (llShowOnly) {
                      handleInfoModal(forensicAnalysis?.DNI);
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-1">
                    <p className="formlabel d-block">{_t("dniNieExtra")}</p>
                    {forensicAnalysis?.DNI?.verifiedSource === true && (
                      <div className="d-flex align-items-center gap-1">
                        <img
                          src={CheckIcon0}
                          alt="Vector Icon"
                          className="validationIcon"
                        />
                      </div>
                    )}
                  </div>

                  <p className="placeholderTest">{dniExtraValue}</p>
                </div>
              </div>
            )}

          {/* Passport Extra field */}
          {haveValue(passportExtraValue) &&
            !isSameValue(passportExtraValue, kycDetails?.value) && (
              <div className="col-md-4 col-6">
                <div
                  className={`Indo_form BorderB2 ${
                    llShowOnly ? "custom-tooltip cursor-pointer" : ""
                  }`}
                  data-tooltip={_t("clickHereToSeeDetails")}
                  onClick={() => {
                    if (llShowOnly) {
                      handleInfoModal(forensicAnalysis?.Passport);
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-1">
                    <p className="formlabel d-block">{_t("passportExtra")}</p>
                    {forensicAnalysis?.Passport?.verifiedSource === true && (
                      <div className="d-flex align-items-center gap-1">
                        <img
                          src={CheckIcon0}
                          alt="Vector Icon"
                          className="validationIcon"
                        />
                      </div>
                    )}
                  </div>

                  <p className="placeholderTest">{passportExtraValue}</p>
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default DetailsPersonalInfo;
